import { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Icosahedron, MeshDistortMaterial } from "@react-three/drei";
import { riskColor } from "../../lib/api";

const Orb = ({ score }) => {
  const ref = useRef();
  const wire = useRef();
  useFrame((_, dt) => {
    const speed = 0.2 + score / 40;
    ref.current.rotation.y += dt * speed;
    ref.current.rotation.x += dt * speed * 0.4;
    wire.current.rotation.y -= dt * speed * 0.6;
  });
  const color = riskColor(score);
  return (
    <group>
      <Icosahedron ref={ref} args={[1.25, 8]}>
        <MeshDistortMaterial color={color} emissive={color} emissiveIntensity={0.35} distort={0.15 + score / 180} speed={1 + score / 25} roughness={0.25} metalness={0.6} />
      </Icosahedron>
      <Icosahedron ref={wire} args={[1.9, 1]}>
        <meshBasicMaterial color={color} wireframe transparent opacity={0.25} />
      </Icosahedron>
    </group>
  );
};

export const RiskOrb = ({ score = 0 }) => (
  <div className="h-72 w-full" data-testid="risk-orb">
    <Canvas camera={{ position: [0, 0, 5], fov: 45 }} gl={{ alpha: true }}>
      <ambientLight intensity={0.4} />
      <directionalLight position={[3, 4, 5]} intensity={1.4} />
      <pointLight position={[-4, -2, -3]} intensity={0.8} color="#7000FF" />
      <Orb score={score} />
    </Canvas>
  </div>
);
